<template>
  <div class="fba-shipment-add">
    <el-form
          ref="form"
          :model="form"
          label-width="110px"
          inline
          style="height: 100%;">
      <anchor-container >
        <anchor-container-item name="基础信息" value="basic-info">
          <el-form-item
              label="仓库"
              prop="warehouseId"
              :rules="[
                { required: true, message: '请选择仓库', trigger: ['blur', 'change'] }
              ]">
            <gj-warehouse-select
                v-model="form.warehouseId"
                active
                :self="false"
                :clearable="false"
                @input="warehouseChange($event)"
            ></gj-warehouse-select>
          </el-form-item>
          <el-form-item
              label="国家"
              prop="countryCode"
              label-width="110px"
              :rules="[
                { required: true, message: '请选择国家', trigger: ['blur', 'change'] }
              ]">
            <gj-select
                v-model="form.countryCode"
                :options="countryOption"
                :clearable="false"
                :filterable="false"
                @input="countryChange"
                placeholder="国家"
                width="150px"
            ></gj-select>
          </el-form-item>
          <el-form-item
              label="贴标方"
              prop="labelType"
              label-width="105px"
              :rules="[
                { required: true, message: '请选择贴标方', trigger: ['blur', 'change'] }
              ]">
            <gj-select
                v-model="form.labelType"
                :options="FbaShipmentEnum.preview_labelPrepTypeOption"
                :clearable="false"
                placeholder="贴标方"
                :filterable="false"
                width="150px"
            ></gj-select>
          </el-form-item>
          <el-form-item
              label="包装类型"
              prop="packageType"
              label-width="130px"
              :rules="[
                { required: true, message: '请选择包装类型', trigger: ['blur', 'change'] }
              ]">
            <gj-select
                v-model="form.packageType"
                :options="FbaShipmentEnum.areCasesRequiredOption"
                placeholder="包装类型"
                :clearable="false"
                :filterable="false"
                width="150px"
            ></gj-select>
          </el-form-item>
          <!-- 发货地址 -->
          <div class="ship-address">
            <el-form-item
                label="发货地址"
                prop="shipmentAddress.countryCode"
                :rules="[
                  { required: true, message: '请选择国家', trigger: ['blur', 'change'] }
                ]">
              <gj-select
                  v-model="form.shipmentAddress.countryCode"
                  placeholder="国家，必填"
                  underline
                  :filterable="false"
                  :options="shipCountryOption"
                  :clearable="false"
                  :disabled="shipmentAddressDisabled"
                  width="160px"
              ></gj-select>
            </el-form-item>
            <el-form-item
                prop="shipmentAddress.name"
                :rules="[
                  { required: true, message: '请输入名称', trigger: ['blur', 'change'] }
                ]">
              <gj-input
                  v-model="form.shipmentAddress.name"
                  placeholder="名称，必填"
                  :disabled="shipmentAddressDisabled"
                  underline
                  width="120px"
              ></gj-input>
            </el-form-item>
            <el-form-item
                prop="shipmentAddress.city"
                :rules="[
                  { required: true, message: '请输入城市', trigger: ['blur', 'change'] }
                ]">
              <gj-input
                  v-model="form.shipmentAddress.city"
                  underline
                  :disabled="shipmentAddressDisabled"
                  placeholder="城市，必填"
                  width="140px"
              ></gj-input>
            </el-form-item>
            <el-form-item
                prop="shipmentAddress.stateOrProvinceCode"
                :rules="[
                  { required: true, message: '请输入洲/省/地区', trigger: ['blur', 'change'] }
                ]">
              <gj-input
                  v-model="form.shipmentAddress.stateOrProvinceCode"
                  placeholder="洲/省/地区，必填"
                  underline
                  :disabled="shipmentAddressDisabled"
                  width="150px"
              ></gj-input>
            </el-form-item>
            <el-form-item
                prop="shipmentAddress.postalCode"
                :rules="[
                  { required: true, message: '请输入邮编', trigger: ['blur', 'change'] }
                ]">
              <gj-input
                  v-model="form.shipmentAddress.postalCode"
                  underline
                  :disabled="shipmentAddressDisabled"
                  placeholder="邮编，必填"
                  width="120px"
              ></gj-input>
            </el-form-item>
            <el-form-item
                prop="shipmentAddress.addressLine1"
                :rules="[
                  { required: true, message: '请输入地址行', trigger: ['blur', 'change'] }
                ]">
              <gj-input
                  v-model="form.shipmentAddress.addressLine1"
                  underline
                  placeholder="地址行，必填"
                  :disabled="shipmentAddressDisabled"
                  width="250px"
              ></gj-input>
              <gj-link v-if="isMeaningful(form.warehouseId) && isMeaningful(form.countryCode)"
                       @click="shipmentAddressDisabled = false">
                <i class="el-icon-edit pen-icon"></i>
              </gj-link>
            </el-form-item>
          </div>
        </anchor-container-item>
        <anchor-container-item name="货件商品" value="shop" class="fba-top_5">
          <template #header-affter>
            <el-button @click="addProduct" class="custom-btn add-custom-btn">添加</el-button>
            <el-button @click="importProduct" class="custom-btn import-custom-btn">导入</el-button>
          </template>
          <gj-table
            ref="gjTable"
            :index="false"
            :data="form.items"
            :columns="columns"
            :show-overflow="false"
            :offset-height="66"
            :auto-resize="false">
          <template v-slot:sku="{row}">
            <div>{{row.sku | defaultShow}}</div>
            <div>
              <gj-tooltip
                  :text-line="1"
                  :content="row.skuName">
                {{row.skuName | defaultShow}}
              </gj-tooltip>
            </div>
          </template>
          <template v-slot:msku="{row}">
            <div>{{row.msku | defaultShow}}</div>
            <div>{{row.fnsku | defaultShow}}</div>
            <div>{{row.asin | defaultShow}}</div>
          </template>
          <template v-slot:op="{ index }">
            <gj-button type="text" @click="deleteItem(index)">删除</gj-button>
          </template>
          <template v-slot:quantity="{row, index}">
            <el-form-item
                :prop="`items.${index}.quantity`"
                :rules="[
                  { required: true, message: '请输入数量', trigger: ['blur', 'change'] },
                  $gjReRule(RE.pt, '请输入大于0的整数')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].quantity"
                  width="120px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:quantityInCase="{row, index}">
            <el-form-item
                :prop="`items.${index}.quantityInCase`"
                :rules="[
                  { required: true, message: '请输入数量', trigger: ['blur', 'change'] },
                  $gjReRule(RE.pt, '请输入大于0的整数')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].quantityInCase"
                  @input="setQuantity(row, index)"
                  width="120px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:box="{row, index}">
            <el-form-item
                :prop="`items.${index}.box`"
                :rules="[
                  { required: true, message: '请输入数量', trigger: ['blur', 'change'] },
                  $gjReRule(RE.pt, '请输入大于0的整数')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].box"
                  @input="setQuantity(row, index)"
                  width="120px">
              </gj-input>
            </el-form-item>
          </template>
        </gj-table>
        </anchor-container-item>
        <template #fotter>
          <div style="text-align: center">
            <gj-button type="primary" @click="previewShipment" :loading="confirmLoading" class="submit-btn confirm-submit">预览</gj-button>
            <gj-button @click="cancel" class="submit-btn cancel-submit">取消</gj-button>
          </div>
        </template>
      </anchor-container>
    </el-form>
  </div>
</template>


<script>

import anchorContainer from '@/views/components/anchorPoint/anchor-container'
import anchorContainerItem from '@/views/components/anchorPoint/anchor-container-item'
import AppAddProductModal from "./add-product-modal";
import AppImportProductModal from "./import-product-modal";
import AppPreviewFbaShipmentModal from "./preview-fba-shipment-modal";
import {
  formDeleteItemMixin,
  formRuleMixin, formValidatorMixin,
  isMeaningfulMixin,
  isMeaninglessMixin,
} from "@/minxins";
import {FbaShipmentEnum} from "../../../enum";
import {countryOption} from "@/utils/options";
import {isMeaningful, isMeaningless, unique} from "@/utils/common";
import {getCountryByWarehouseId, getShipFromAddress,} from "@/api/logistics";
import {getTransferFbaShipment} from "@/api/warehouse";

export default {
  name: "add-fba-shipment-modal",
  components: {
    anchorContainer,
    anchorContainerItem
  },
  mixins: [formDeleteItemMixin, isMeaninglessMixin,
      isMeaningfulMixin, formRuleMixin, formValidatorMixin],
    props: {
      transferOrders: {
        default: null
      },
      deliveryPlan:{
        required:false,
        default:null
      }
    },
    data() {
      return {
        loading: false,
        form: {
          warehouseId: null,
          countryCode: null,
          labelType: null,
          packageType: FbaShipmentEnum.areCasesRequired.MIX,
          shipmentAddress: {
            countryCode: null,
            name: null,
            city: null,
            stateOrProvinceCode: null,
            postalCode: null,
            addressLine1: null,
          },
          items: [],
        },
        columns: [],
        tableData: [],
        countryOption: [],
        FbaShipmentEnum: FbaShipmentEnum,
        shipmentAddressDisabled: true,
        shipCountryOption: countryOption,
        initing: false,
        confirmLoading:false
      }
    },
    watch: {
      'form.packageType': {
        handler: function (packageType) {
          this.columns = [
            {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '50px'},
            {id: 'sku', header: 'SKU/产品名称', field: 'slot:sku', minWidth: '200px'},
            {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '150px'},
            packageType ? {id: 'quantityInCase', header: '单箱数量', field: 'slot:quantityInCase', minWidth: '120px'} : null,
            packageType ? {id: 'box', header: '箱数', field: 'slot:box', minWidth: '120px'} : null,
            {id: 'quantity', header: '申报量', field: packageType ? 'quantity' : 'slot:quantity',
              minWidth: '100px', align: packageType ? 'right' : 'left', required: !packageType},
            {id: 'maxQuantityShipped', header: '建议最大申报量', help: '此数据来源于亚马逊后台【补货】报表中的"最大发货量"数值',
              field: 'maxQuantityShipped', minWidth: '180px', align: 'right'},
            {id: 'op', header: '操作', field: 'slot:op', width: '100px', notCustomColumn: true},
          ].filter(e => isMeaningful(e));
        },
        immediate: true
      }
    },
    created() {
      if (this.transferOrders) {
        this.loading = true;
        getTransferFbaShipment(this.transferOrders.map(item => item.id))
          .then(data => {
            this.initing = true;
            this.form.warehouseId = data.warehouseId;
            this.form.countryCode = data.countryCode;
            this.form.items = data.items;
            this.getShipFromAddress();
            getCountryByWarehouseId({warehouseId: this.form.warehouseId})
              .then(data => {
                this.countryOption = data;
              })
              .complete(() => this.loading = false);
            setTimeout(() => {
               this.init = false;
            });
          });
      }
      if(this.deliveryPlan){  // 通过发货计划 创建货件
        this.getDeliveryPlan(this._.cloneDeep(this.deliveryPlan))
      }
    },
    methods: {
      getDeliveryPlan(data){
        this.initing = true;
        this.form.warehouseId = data.arrivalWarehouseId;
        this.form.countryCode = data.shipToCountryCode;
        this.form.packageType = data.areCasesRequired;
        data.goodsList.forEach(item=>{
          if(item.numberOfCase)  item.box = item.numberOfCase
          if(item.quantityShipped)  item.quantity = item.quantityShipped
        })
        this.form.items = data.goodsList;
        this.getShipFromAddress();
        getCountryByWarehouseId({warehouseId: this.form.warehouseId})
            .then(data => {
              this.countryOption = data;
            })
            .complete(() => this.loading = false);
        setTimeout(() => {
          this.init = false;
        });
      },

      addProduct() {
        if (isMeaningless(this.form.warehouseId)
          || isMeaningless(this.form.countryCode)) {
          this.$gjMessage.error('请先选择仓库和国家');
          return;
        }
        const hideMskuList = this.form.items.map(item => item.msku);
        this.$gjCreate(AppAddProductModal, {
          props: {
            warehouseId: this.form.warehouseId,
            countryCode: this.form.countryCode,
            hideMskuList,
          },
          on: {
            select: (products) => {
              this.form.items = unique([].concat(this.form.items).concat(products || []), 'msku')
                .map(item => ({
                  ...item,
                  quantity: item.quantity || null
                }));
            }
          }
        });
      },
      warehouseChange(warehouseId) {
        if (this.initing || isMeaningless(warehouseId)) {
          return;
        }
        this.form.items = [];
        this.countryOption = [];
        this.form.countryCode = null;
        getCountryByWarehouseId({
          warehouseId
        })
          .then((data) => {
            this.countryOption = data;
            if (isMeaningful(this.countryOption) && this.countryOption.length === 1) {
              this.form.countryCode = this.countryOption[0].id;
              this.countryChange();
            }
          });
        this.getShipFromAddress();
      },
      countryChange() {
        if (this.initing) {
          return;
        }
        this.form.items = [];
        this.getShipFromAddress();
      },
      getShipFromAddress() {
        const warehouseId = this.form.warehouseId;
        const countryCode = this.form.countryCode;
        if (isMeaningless(warehouseId) || isMeaningless(countryCode)) {
          return;
        }
        getShipFromAddress({
          warehouseId,
          countryCode
        })
          .then((data) => {
            Object.assign(this.form.shipmentAddress, data);
          });
      },
      importProduct() {
        if (isMeaningless(this.form.warehouseId)
          || isMeaningless(this.form.countryCode)) {
          this.$gjMessage.error('请先选择仓库和国家');
          return;
        }
        this.$gjCreate(AppImportProductModal, {
          props: {
            areCasesRequired: this.form.packageType,
            hideMskuList: [], // this.form.items.map(item => item.msku)
            warehouseId: this.form.warehouseId,
            countryCode:this.form.countryCode
          },
          on: {
            importSuccess: (data) => {
              this.updateItems(data);
            },
            importPartSuccess: (data) => {
              this.updateItems(data);
            }
          }
        });
      },
      updateItems(data) {
        if (isMeaningful(data)) {
          data.forEach(newItem => {
            const find = this.form.items.find(oldItem => newItem.msku === oldItem.msku);
            if (find) {
              Object.assign(find, this.mapToItem(newItem));
            } else {
              this.form.items.push(this.mapToItem(newItem));
            }
          });
        }
      },
      mapToItem(item) {
        return {
          skuImageUrl: item.skuImageUrl,
          sku: item.sku,
          skuName: item.skuName,
          msku: item.msku,
          fnsku: item.fnsku,
          asin: item.asin,
          maxQuantityShipped: item.maxQuantityShipped,
          quantity: item.quantityShipped,
          box: item.numberOfCase,
          quantityInCase: item.quantityInCase
        };
      },
      previewShipment() {
        if (this.form.items.length === 0) {
          this.$gjMessage.error('请先添加商品');
          return;
        }
        if (this.formValidate()) {
          const previewShipmentParams = {
            warehouseId: this.form.warehouseId,
            areCasesRequired: this.form.packageType,
            labelPrepPreference: this.form.labelType,
            shipToCountryCode: this.form.countryCode,
            shipFromAddress: {
              name: this.form.shipmentAddress.name,
              addressLine1: this.form.shipmentAddress.addressLine1,
              city: this.form.shipmentAddress.city,
              stateOrProvinceCode: this.form.shipmentAddress.stateOrProvinceCode,
              postalCode: this.form.shipmentAddress.postalCode,
              countryCode: this.form.shipmentAddress.countryCode
            },
            items: this.form.items.map(item => ({
              asin: item.asin,
              fnsku: item.fnsku,
              msku: item.msku,
              quantityInCase: this.form.packageType === FbaShipmentEnum.areCasesRequired.ORIGIN ? item.quantityInCase : null,
              quantityShipped: item.quantity,
              shipPlanCodeList: item.shipPlanCodeList || [],
              sku: item.sku,
              skuImageUrl: item.skuImageUrl,
              skuName: item.skuName
            }))
          };
          this.$gjCreate(AppPreviewFbaShipmentModal, {
            props: {
              previewShipmentParams,
            },
            on: {
              created: (shipmentIds) => {
                this.$emit('created', shipmentIds);
                sessionStorage.setItem('fba-shipment-refresh', 1)
                this.$router.push({path: '/logistics/fba-shipment'})
                this.$gjDestroy && this.$gjDestroy();
              }
            }
          });
        }
      },
      setQuantity(row, index) {
        if (!isNaN(row.quantityInCase) && !isNaN(Number(row.box))) {
          this.form.items[index].quantity = Number(row.quantityInCase) * Number(row.box);
        }
      },
      cancel() {
        this.$router.push('/logistics/fba-shipment')
      }
    }
}
</script>

<style scoped lang="scss">
.fba-shipment-add {
  height: 100%;
  // padding: 15px 15px 30px 15px;
  box-sizing: border-box;
}
.ship-address /deep/ .el-input.is-disabled .el-input__inner {
    background: #fff;
  }

/deep/ .custom-btn {
  color: #fff;
  width: 48px;
  height: 22px;
  border-radius: 2px;
  font-size: 12px;
  border: none;
  padding: 0;
  line-height: 22px;
  &.add-custom-btn {
    background: #1F6EEF;
  }
  &.import-custom-btn {
    background: #fff;
    color: #333;
    border: 1px solid #D8DADD;
  }
}

/deep/ .submit-btn {
  width: 60px;
  height: 32px;
  border-radius: 2px;
  font-size: 12px;
  border: none;
  padding: 0;
  line-height: 30px;
  &.confirm-submit {
    background: #1F6EEF;
  }
  &.cancel-submit {
    border: 1px solid #4994FC;
    color: #1F6EEF;
  }
}
/deep/ .container-right-main{
  padding-top: 0 !important;
}
/deep/ .gj-link{
  margin-left: 12px;
}
/deep/ .gj-underline-input{
  margin-top: 0;
}
.fba-top_5{
  /deep/ .anchor-container-item-header{
    margin-top: 5px;
  }
}
</style>
